import { render, staticRenderFns } from "./RegistroVista.vue?vue&type=template&id=7139b302&scoped=true&"
import script from "./RegistroVista.vue?vue&type=script&lang=js&"
export * from "./RegistroVista.vue?vue&type=script&lang=js&"
import style0 from "./RegistroVista.vue?vue&type=style&index=0&id=7139b302&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139b302",
  null
  
)

export default component.exports